import { useNavigate, useLocation } from "react-router";
import { ReactNode, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

interface AuthGuardProps {
    children: ReactNode;
}

export default function AuthGuard({ children }: AuthGuardProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (token && jwtDecode(token).exp! > Date.now() / 1000) {
            setIsChecking(false);
            return;
        }

        localStorage.setItem("initialUrl", location.pathname);
        navigate('/login', { replace: true });
    }, [location, navigate]);

    if (isChecking) {
        return null;
    }

    return <>{children}</>;
}